export default __webpack_public_path__ + "a6ac1119e278fd77f7aa8ecaf165f9b2.png";